'use client';

import clsx from 'clsx';
import { FC, useState } from 'react';

import Image from '@/components/Image';
import AnimatedSubmitButton from '@/components/shared/AnimatedSubmitButton';
import { Typography } from '@/components/shared/Typography';
import { WebsiteAuditFormDto } from '@/components/WebsiteProdPage/ScheduleMeeting/types';
import { useModal } from '@/hooks/useModal';

import css from './style.module.scss';

interface Props {
	data: WebsiteAuditFormDto;
	className?: string;
}

const FormBlock: FC<Props> = ({ data, className }) => {
	const { openModal } = useModal();
	const [site, setSite] = useState('');

	return (
		<div className={clsx(css.card, className)}>
			<Typography uppercase variant="h5" tag="h3" className={css.title}>
				{data.title}
			</Typography>
			<Typography variant="body-m" tag="p" className={css.description}>
				{data.description}
			</Typography>

			<div className={css.form}>
				<div className={css.inputWrapper}>
					<input
						type="text"
						className={css.input}
						placeholder="Your website address"
						value={site}
						onChange={e => setSite(e.target.value)}
					/>
				</div>
				<AnimatedSubmitButton
					onClick={() => openModal('WEBSITE_AUDIT', { data, site, onSiteChange: setSite })}
				>
					{data.buttonLabel || 'Analize my website'}
				</AnimatedSubmitButton>
			</div>

			<Image
				className={css.image}
				src="/assets/images/website-prod-page/schedule-meeting/laptop.webp"
				width={310}
				height={280}
				alt=""
			/>
		</div>
	);
};

export default FormBlock;
